// extracted by mini-css-extract-plugin
export default {"checkboxItem":"root_formik-checkbox-group-field-module__checkboxItem___pfoAi","label":"root_formik-checkbox-group-field-module__label___M7au6"};